/* 对axios封装，相应状态吗 */
/* vue中ajax请求 插件 */
import axios from 'axios';
/* vue 路由跳转 */
import router from '@/router';
import baseUrl from '@/api/baseUrl';

import Vue from 'vue';
import { clearLoginInfo } from '../utils';
/* 删除Token跳转到登录页面重新登录 */

// 创建axios实例
const service = axios.create({
  baseURL: baseUrl.BASE_API, // api的base_url
  timeout: 15000, // 请求超时时间,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json; charset=utf-8'
  }
});

// request拦截器
service.interceptors.request.use(
  config => {
    config.headers['token'] = Vue.ls.get('token'); // 请求头带上token
    return config;
  },
  error => {
    Promise.reject(error);
  }
);

/* ajax请求返回拦截 */
service.interceptors.response.use(
  response => {
    /* 正常请求返回状态的判断 */
    console.log(response.data.code);
    if (response.data && response.data.code === 401) {
      clearLoginInfo();
      router.push({
        name: 'login'
      });
    }
    return response;
  },
  err => {
    return Promise.resolve(err);
  }
);

export default service;
